import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { POSTS } from '../data/content.js'

export default function Blog() {
  const { t } = useTranslation()

  return (
    <section className="section">
      <div className="container">
        <p className="eyebrow">Almus</p>
        <h1 className="section-title">{t('blog.title')}</h1>
        <div className="grid-2">
          {POSTS.map((post) => {
            const item = t(`blogItems.${post.id}`, { returnObjects: true })
            return (
              <Link key={post.id} to={`/blog/${post.slug}`} className="card blog-card">
                <h3>{item.title}</h3>
                <p className="excerpt">{item.excerpt}</p>
              </Link>
            )
          })}
        </div>
      </div>
    </section>
  )
}